import DeployModal from './DeployModal.container'

export default DeployModal
